import { FC } from 'react';
import { Box, Center } from '@chakra-ui/react';

import Button, { ButtonProps } from 'components/_core/Button';

const ListFetchMoreButton: FC<ButtonProps> = (props) => (
  <Box paddingTop="space-24">
    <Center>
      <Button icon="arrow-down" variant="secondary" {...props} />
    </Center>
  </Box>
);

export default ListFetchMoreButton;
